const projSetupTitleBarMenu = {
  contentType: "projSetup",
  menuItems: [
    {
      _menuId: "projSetupTitleBarMenu_1",
      type: "TITLEBAR_MENU_ITEM",
      label: "Print",
      action: "print"
    }
  ],
  toolbar: [
    {
      _iconId: "projSetupTitleBarToolbar_1",
      icon: "print",
      action: "print"
    }
  ]
};

export default projSetupTitleBarMenu;
